import { render, staticRenderFns } from "./ContractProps.vue?vue&type=template&id=87d748c4&scoped=true&"
import script from "./ContractProps.vue?vue&type=script&lang=js&"
export * from "./ContractProps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d748c4",
  null
  
)

export default component.exports